import { API_BASE_URL, apiRequest, type ApiRequestOptions } from '../http.ts';
import type { APIResponse, MessageData } from './types/common.ts';
import type { NotificationsResponse, UnreadCountResponse } from './types/notifications.ts';

export interface NotificationPreferences {
  notify_email_signal?: boolean;
  notify_email_fill?: boolean;
  notify_email_error?: boolean;
  notify_email_warning?: boolean;
  notify_email_system?: boolean;
}

/** Notification retrieval, acknowledgement, and preference endpoints. */
export class NotificationsApiService {
  private readonly baseUrl: string;

  constructor(baseUrl: string = API_BASE_URL) {
    this.baseUrl = baseUrl;
  }

  private request<T>(endpoint: string, options: ApiRequestOptions = {}): Promise<T> {
    return apiRequest<T>(endpoint, options);
  }

  getNotifications(limit = 50, unreadOnly = false): Promise<NotificationsResponse> {
    return this.request<NotificationsResponse>(
      `${this.baseUrl}/notifications?limit=${limit}&unread_only=${unreadOnly}`,
    );
  }

  getUnreadCount(): Promise<UnreadCountResponse> {
    return this.request<UnreadCountResponse>(
      `${this.baseUrl}/notifications/unread-count`,
      { timeoutMs: 2000 },
    );
  }

  markNotificationRead(id: number): Promise<APIResponse<null>> {
    return this.request<APIResponse<null>>(`${this.baseUrl}/notifications/${id}/read`, {
      method: 'POST',
    });
  }

  markAllRead(): Promise<APIResponse<null>> {
    return this.request<APIResponse<null>>(`${this.baseUrl}/notifications/read-all`, {
      method: 'POST',
    });
  }

  updateNotificationPreferences(preferences: NotificationPreferences): Promise<APIResponse<MessageData>> {
    return this.request<APIResponse<MessageData>>(`${this.baseUrl}/auth/me/preferences`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(preferences),
    });
  }
}
